(function () {
  var SEEN_KEY = 'thyred-exit-popup-seen';   // shown once per browser
  var DONE_KEY = 'thyred-exit-popup-done';   // already subscribed
  var MIN_DWELL_MS = 6000;                    // don't fire in the first few seconds

  function stored(key) {
    try { return localStorage.getItem(key) === '1'; } catch (e) { return false; }
  }
  function remember(key) {
    try { localStorage.setItem(key, '1'); } catch (e) {}
  }
  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function init() {
    var overlay = document.getElementById('ThyredExitPopup');
    if (!overlay) return;
    if (stored(SEEN_KEY) || stored(DONE_KEY)) return;

    // Oliver 2026-10-17: exit intent ONLY, no timers. Desktop = cursor leaves
    // through the top; touch = a fast scroll back up after reading down the page.
    var card = overlay.querySelector('.xp-card');
    var startedAt = Date.now();
    var shown = false, armed = false, lastY = window.pageYOffset;

    function arm() {
      if (armed) return;
      armed = true;
      document.addEventListener('mouseout', onMouseOut);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    function disarm() {
      document.removeEventListener('mouseout', onMouseOut);
      window.removeEventListener('scroll', onScroll);
    }

    function eligible() {
      return !shown && (Date.now() - startedAt) > MIN_DWELL_MS;
    }

    // Desktop: cursor exits through the top of the viewport.
    function onMouseOut(e) {
      if (!eligible()) return;
      if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) open();
    }

    // Touch/no-mouse: a deliberate fast scroll back toward the top after the
    // visitor has read some way down reads as leave-intent.
    function onScroll() {
      var y = window.pageYOffset;
      var goingUp = y < lastY - 6;
      if (eligible() && goingUp && lastY > 700 && y < 400) open();
      lastY = y;
    }

    // Clarity 2026-10-17: the 09-21 mobile buyer added to cart, then this popup
    // opened over the cart drawer's Checkout button and they left. Never
    // interrupt someone with the cart open or something in it.
    function cartBusy() {
      var drawer = document.querySelector('cart-drawer');
      return (drawer && drawer.classList.contains('active')) ||
        !!document.querySelector('.cart-count-bubble');
    }

    function open() {
      if (shown) return;
      if (cartBusy()) return;
      shown = true;
      remember(SEEN_KEY);
      disarm();
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('in'); });
      var input = overlay.querySelector('input[type="email"]');
      if (input) setTimeout(function () { try { input.focus(); } catch (e) {} }, 320);
      document.addEventListener('keydown', onKey);
    }

    function close() {
      overlay.classList.remove('in');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { overlay.hidden = true; }, 300);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    // Close on backdrop click (but not when clicking inside the card).
    overlay.addEventListener('click', function (e) {
      if (!card.contains(e.target)) close();
    });
    overlay.querySelectorAll('[data-xp-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    // On a valid submit, swap to the success state and reveal the code.
    // The shared thyred-newsletter.js still handles the actual POST + captcha.
    var form = overlay.querySelector('.xp-form');
    var capture = overlay.querySelector('[data-xp-capture]');
    var success = overlay.querySelector('[data-xp-success]');
    if (form) {
      form.addEventListener('submit', function () {
        var emailEl = form.querySelector('input[type="email"]');
        if (!emailEl || !emailValid(emailEl.value.trim())) return; // let shared JS show the error
        remember(DONE_KEY);
        if (capture && success) {
          capture.hidden = true;
          success.hidden = false;
        }
      });
    }

    // Click-to-copy the discount code.
    var codeBtn = overlay.querySelector('[data-xp-code]');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-code') || '';
        var hint = codeBtn.querySelector('.xp-code-hint');
        function done() {
          codeBtn.classList.add('copied');
          if (hint) hint.textContent = 'Copied';
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {});
        } else {
          try {
            var t = document.createElement('textarea');
            t.value = code; document.body.appendChild(t); t.select();
            document.execCommand('copy'); document.body.removeChild(t); done();
          } catch (e) {}
        }
      });
    }

    arm();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
